export default "__VITE_ASSET__ByUfcvKP__"